import { defineMessages } from 'react-intl';

const translations = {
  actions: {
    back: {
      id: 'actions.back',
      defaultMessage: 'Back',
      description: 'Label of the back action',
    },
    finish: {
      id: 'actions.finish',
      defaultMessage: 'Finish',
      description: 'Label of the finish action',
    },
    next: {
      id: 'actions.next',
      defaultMessage: 'Next',
      description: 'Label of the next action',
    },
  },
  feedback: {
    itemNotProcessed: {
      id: 'pages.pick.feedback.itemNotProcessed',
      defaultMessage: 'Item could not be processed',
      description: 'Error message of the save item action',
    },
    missingItemsRequestFailed: {
      id: 'pages.pick.feedback.missingItemsRequestFailed',
      defaultMessage: 'Checking missing items failed',
      description: 'Error message of the check missing items action',
    },
  },
  lessPickedDialog: {
    title: {
      id: 'pages.pick.lessPickedDialog.title',
      defaultMessage: 'Less picked than requested',
      description: 'Title of the less picked than requested dialog',
    },
    description: {
      id: 'pages.pick.lessPickedDialog.description',
      defaultMessage:
        'You have picked less items than the requested quantity. Are you sure you would like to continue? Otherwise compare how much items you picked to the requested amount.',
      description: 'Description of the less picked dialog',
    },
    buttons: {
      continue: {
        id: 'actions.continue',
        defaultMessage: 'Continue',
        description: 'Label of the continue button',
      },
      check: {
        id: 'actions.check',
        defaultMessage: 'Check',
        description: 'Label of the Check button',
      },
    },
  },
  lessThanParcelQuantityDialog: {
    title: {
      id: 'pages.pick.lessThanParcelQuantityDialog.title',
      defaultMessage: 'Remove item from parcel',
      description: 'Title of the less than parcel quantity dialog',
    },
    description: {
      id: 'pages.pick.lessThanParcelQuantityDialog.description',
      defaultMessage:
        'You tried to lower the quantity of this item more than there are packed in the current parcel. Switch to another parcel to unpack the rest of this item.',
      description: 'description of the less than parcel quantity dialog',
    },
    buttons: {
      close: {
        id: 'actions.close',
        defaultMessage: 'Close',
        description: 'label of the close button',
      },
      changeParcels: {
        id: 'actions.changeParcels',
        defaultMessage: 'Change parcel',
        description: 'label of the change parcel action',
      },
    },
  },
  noParcelQuantityDialog: {
    title: {
      id: 'pages.pick.noParcelQuantityDialog.title',
      defaultMessage: 'Remove product from parcel',
      description: 'Title of the no parcel quantity dialog',
    },
    description: {
      id: 'pages.pick.noParcelQuantityDialog.description',
      defaultMessage:
        'You have already removed this item from the current parcel. Switch to another parcel to remove more of this item.',
      description: 'Description of the no parcel quantity dialog',
    },
    buttons: {
      close: {
        id: 'actions.close',
        defaultMessage: 'Close',
        description: 'label of the close button',
      },
      changeParcels: {
        id: 'actions.changeParcels',
        defaultMessage: 'Change parcel',
        description: 'label of the change parcel action',
      },
    },
  },
  requestedQuantityPickedDialog: {
    title: {
      id: 'pages.pick.requestedQuantityPickedDialog.title',
      defaultMessage: 'Requested amount picked',
      description: 'Title of the requested amount picked dialog',
    },
    description: {
      id: 'pages.pick.requestedQuantityPickedDialog.description',
      defaultMessage:
        "You have already picked the requested amount of this item. Check if you didn't pick too much.",
      description: 'description of the requested quantity picked dialog',
    },
    buttons: {
      close: {
        id: 'actions.close',
        defaultMessage: 'Close',
        description: 'label of the close button',
      },
    },
  },
};

export default defineMessages(translations);
